import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmallApprovedIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 28 28",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 14,
			cy: 14,
			r: 14,
			fill: "#10B981"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "path-2-outside-1_997_17592",
			maskUnits: "userSpaceOnUse",
			x: 5.35645,
			y: 6.39062,
			width: 17,
			height: 15,
			fill: "black",
			children: [/* @__PURE__ */ _jsx("rect", {
				fill: "white",
				x: 5.35645,
				y: 6.39062,
				width: 17,
				height: 15
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M21.2737 7.69116C20.6911 7.22116 19.8379 7.31241 19.3679 7.89497L11.6072 17.5142L8.67012 14.5771C8.14083 14.0478 7.28269 14.0478 6.75341 14.5771C6.22412 15.1064 6.22412 15.9645 6.75341 16.4938L10.5868 20.3272C10.7225 20.4629 10.8797 20.5637 11.0474 20.6299C11.6205 20.9874 12.3835 20.869 12.8183 20.33L21.4775 9.597C21.9475 9.01444 21.8563 8.16117 21.2737 7.69116Z"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.2737 7.69116C20.6911 7.22116 19.8379 7.31241 19.3679 7.89497L11.6072 17.5142L8.67012 14.5771C8.14083 14.0478 7.28269 14.0478 6.75341 14.5771C6.22412 15.1064 6.22412 15.9645 6.75341 16.4938L10.5868 20.3272C10.7225 20.4629 10.8797 20.5637 11.0474 20.6299C11.6205 20.9874 12.3835 20.869 12.8183 20.33L21.4775 9.597C21.9475 9.01444 21.8563 8.16117 21.2737 7.69116Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3679 7.89497L18.9627 7.56813V7.56813L19.3679 7.89497ZM21.2737 7.69116L21.6006 7.28604V7.28604L21.2737 7.69116ZM11.6072 17.5142L11.2392 17.8823L11.6487 18.2918L12.0123 17.8411L11.6072 17.5142ZM8.67012 14.5771L8.30205 14.9452L8.67012 14.5771ZM6.75341 14.5771L7.12148 14.9452H7.12148L6.75341 14.5771ZM6.75341 16.4938L6.38534 16.8619H6.38534L6.75341 16.4938ZM10.5868 20.3272L10.2188 20.6953L10.2188 20.6953L10.5868 20.3272ZM11.0474 20.6299L11.323 20.1882L11.2826 20.163L11.2383 20.1456L11.0474 20.6299ZM12.8183 20.33L13.2234 20.6568L12.8183 20.33ZM21.4775 9.597L21.8826 9.92385L21.4775 9.597ZM19.773 8.22182C20.0625 7.863 20.588 7.80679 20.9469 8.09629L21.6006 7.28604C20.7942 6.63553 19.6133 6.76182 18.9627 7.56813L19.773 8.22182ZM12.0123 17.8411L19.773 8.22182L18.9627 7.56813L11.2021 17.1874L12.0123 17.8411ZM8.30205 14.9452L11.2392 17.8823L11.9753 17.1461L9.03819 14.209L8.30205 14.9452ZM7.12148 14.9452C7.44748 14.6192 7.97604 14.6192 8.30205 14.9452L9.03819 14.209C8.30562 13.4765 7.1179 13.4765 6.38534 14.209L7.12148 14.9452ZM7.12148 16.1257C6.79548 15.7997 6.79548 15.2712 7.12148 14.9452L6.38534 14.209C5.65277 14.9416 5.65277 16.1293 6.38534 16.8619L7.12148 16.1257ZM10.9549 19.9592L7.12148 16.1257L6.38534 16.8619L10.2188 20.6953L10.9549 19.9592ZM11.2383 20.1456C11.1357 20.1051 11.0391 20.0434 10.9549 19.9592L10.2188 20.6953C10.4058 20.8823 10.6236 21.0223 10.8566 21.1141L11.2383 20.1456ZM12.4132 20.0031C12.1456 20.3348 11.6755 20.4082 11.323 20.1882L10.7719 21.0715C11.5655 21.5666 12.6213 21.4032 13.2234 20.6568L12.4132 20.0031ZM21.0724 9.27016L12.4132 20.0031L13.2234 20.6568L21.8826 9.92385L21.0724 9.27016ZM20.9469 8.09629C21.3057 8.38578 21.3619 8.91134 21.0724 9.27016L21.8826 9.92385C22.5332 9.11754 22.4069 7.93656 21.6006 7.28604L20.9469 8.09629Z",
			fill: "#10B981",
			mask: "url(#path-2-outside-1_997_17592)"
		})
	]
});
export default SvgSmallApprovedIcon;
